<script lang="ts">
    import LanguageSelector from "../../shared_components/LanguageSelector.svelte";
    import lang from '../../lang/language';
    import Search from "../../shared_components/Search.svelte";
    import {getUrlParam} from "../../helpers/url";
    import Divider from "../../shared_components/Divider.svelte";
    import ServicesAndMap from "./ServicesAndMap.svelte";
    import StickyWishlist from "../../shared_components/wishlist/StickyWishlist.svelte";
import Cart from "../../shared_components/Cart.svelte";

    let search_title;
    switch (getUrlParam('type')) {
        case '0':
            search_title = lang.search_accommodation;
            break;
        case '1':
            search_title = lang.search_activity;
            break;
        case '2':
            search_title = lang.search_restaurant;
            break;
        case '3':
            search_title = lang.search_product;
            break;
        default:
            search_title = lang.search_everything;
            break;
    }

</script>

<Cart />
<div class='breadcrumb with-image'>
    <div class="row space-between">
        <div>
            <a href='/'>{lang.home}</a>
            <span class='separator'>|</span>
            <span>{lang.list}</span>
        </div>
        <div>
            <LanguageSelector/>
        </div>
    </div>
    <div class="row">
        <h1 class="title">{search_title}</h1>
    </div>
</div>
<div class='box'>
    <Search />
    <Divider>
        <ServicesAndMap slot='col-1'/>
        <StickyWishlist slot='sticky'/>
    </Divider>
</div>


<style></style>